import React from "react";
import "./ClickableTile.css";
import Tile from "../tile/Tile";

export default function ClickableTile({ content, link }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="clickable-tile-link"
    >
      <div className="clickable-tile">
        <Tile content={content} />
      </div>
    </a>
  );
}
